export enum PaymentDirections {
    PAY_IN = 'PAY_IN',
    PAY_OUT = 'PAY_OUT'
}
